<template>
  <v-dialog v-model="input" max-width="720">
    <customer-form
      v-model="customer"
      :isUpdating="isUpdating"
      @handle-change="input = false"
    ></customer-form>
  </v-dialog>
</template>
<script>
import CustomerForm from "./CustomerForm.vue";
export default {
  name: "CustomerDialog",
  components: { "customer-form": CustomerForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
    pCustomer: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    customer: {
      get() {
        return this.pCustomer;
      },
      set(val) {
        this.$emit("handle-change", val);
      },
    },
  },
};
</script>
